/**
* Created by lobin on 2020/6/17.
*/
<template>
  <span class="excom-icon">
    <img :src="exicons[this.excom]" class="excom-icon-img" >
    {{ text }}
    <a-icon type="retweet" @click="handChangePartner"/>
  </span>
</template>

<script type="text/babel">
import exicons from '@/assets/exicons';

export default {
  props: ['excom', 'text'],
  data() {
    return {
      exicons,
    };
  },
  methods: {
    handChangePartner() {
      this.$emit('changePartner');
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
  .excom-icon {
    &-img {
      width: 20px;
    }
    &:hover {
      color: #1890ff;
      .anticon {
        display: inline-block;
      }
    }
    .anticon {
      cursor: pointer;
      display: none;
      &:hover {
        opacity: .7;
      }
    }
  }
</style>
